var map = {
	"./bmp": 875,
	"./bmp.js": 875,
	"./gif": 876,
	"./gif.js": 876,
	"./jpg": 877,
	"./jpg.js": 877,
	"./png": 878,
	"./png.js": 878,
	"./psd": 879,
	"./psd.js": 879,
	"./svg": 880,
	"./svg.js": 880,
	"./tiff": 881,
	"./tiff.js": 881,
	"./webp": 882,
	"./webp.js": 882
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 873;


//////////////////
// WEBPACK FOOTER
// ./~/markdown-it-imsize/lib/imsize/types ^\.\/.*$
// module id = 873
// module chunks = 1